import { useEffect, useMemo } from "react";

import { IndicationName, IRouteConfig } from "@/app/routing/types";
import { useLateInitContext } from "@/shared/hooks/use-late-init-context";

import { NavigationMenuContext } from "../model/navigation-menu/context/navigation-menu";
import { checkIsSubMenu } from "../utils";

interface UseLoadIndicationProps {
	partyUUID?: string;
	uuid?: string;
	currentTab?: string;
	routeItems: IRouteConfig[];
}

const getAllIndicationInCurrentMenu = (routeItems: IRouteConfig[]) => {
	const indicationKeys: IndicationName[] = [];

	routeItems.forEach((route) => {
		const { menuItem, children } = route;
		if (menuItem?.indicationName) indicationKeys.push(menuItem.indicationName);

		if (checkIsSubMenu(route)) {
			const childIndicationKeys = getAllIndicationInCurrentMenu(children as IRouteConfig[]);
			indicationKeys.push(...childIndicationKeys);
		}
	});

	return indicationKeys;
};

export const useLoadIndication = ({
	partyUUID,
	uuid,
	currentTab,
	routeItems,
}: UseLoadIndicationProps) => {
	const state = useLateInitContext(NavigationMenuContext);

	const allIndicationInCurrentMenu = useMemo(
		() => getAllIndicationInCurrentMenu(routeItems),
		[routeItems]
	);

	useEffect(() => {
		state.loadIndication({ partyUUID, uuid, currentTab, allIndicationInCurrentMenu });
	}, [state, partyUUID, uuid, currentTab, allIndicationInCurrentMenu]);
};
